import React from 'react';

const CheckbocControl = (props) => {
    const { value, onClick } = props;

    return <>
        <button className={`f-toggle-control ${value ? 'on' : 'off'}`} onClick={() => { onClick(!value); }}>
            <span className="pin" />
        </button>
    </>;
};

export { CheckbocControl };